import { StateSummary } from '../../../../../../api/theHive/redeProto/types';
import { heatColor } from '../../theme/tokens';
import { formatInt, formatPct } from '../../utils/format';
import { HeatBadge, Table, TableWrap } from './styles';

interface StatesTableProps {
  states: StateSummary[];
}

export function StatesTable({ states }: StatesTableProps): JSX.Element {
  return (
    <TableWrap>
      <Table>
        <thead>
          <tr>
            <th>UF</th>
            <th>Região</th>
            <th className="num">Meta</th>
            <th className="num">Credenciados</th>
            <th className="num">Atingimento</th>
            <th className="num">Polos</th>
            <th className="num">Municípios</th>
          </tr>
        </thead>
        <tbody>
          {states.map((state) => (
            <tr key={state.ufCode}>
              <td>
                <strong>{state.uf}</strong>
              </td>
              <td>{state.region}</td>
              <td className="num">{formatInt(state.goal)}</td>
              <td className="num">{formatInt(state.accredited)}</td>
              <td className="num">
                <HeatBadge color={heatColor(state.achievement)}>
                  {formatPct(state.achievement)}
                </HeatBadge>
              </td>
              <td className="num">{formatInt(state.polesCount)}</td>
              <td className="num">{formatInt(state.coveredCities)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </TableWrap>
  );
}
